package com.platforma.chat_domain.use_case.message

import team.platforma.chat_data.repository.messages.MokMessagesRepository
import team.platforma.wrapper.Response

class NetworkMessageUseCase(
    private val mokMessagesRepository: MokMessagesRepository
) {
    suspend fun createNewChat(modelId: Long, chatId: Long, text: String): Response<Long> {
        return mokMessagesRepository.createNewChat(
            modelId = modelId,
            chatId = chatId,
            text = text
        )
    }

    suspend fun sendActiveChatMessage(modelId: Long, chatId: Long, userMessage: String, aiContext: String) {
        return mokMessagesRepository.sendActiveChatMessage(modelId, chatId, userMessage, aiContext)
    }

    suspend fun stopGeneration() {
        mokMessagesRepository.stopGeneration()
    }
}